import { useRouter } from 'next/router';
import { filterValuesSeparator } from 'shared-helpers/consts';
import {
  AchievementsViewAdministered,
  AchievementsViewAllAchievements,
  AchievementsViewAvailable,
  AchievementsViewSearch,
  AchievementsViewUser
} from '.';

const Achievements = () => {
  const router = useRouter();

  const type = router?.query.type as
    | 'active'
    | 'administered'
    | 'all'
    | 'available'
    | 'search';

  const queryParams = Object.keys(router.query)
    .filter((param) => param !== 'type')
    .map((param) => {
      const value = router.query[param];
      return Array.isArray(value)
        ? `&${param}=${encodeURIComponent(value.join(filterValuesSeparator))}`
        : `&${param}=${encodeURIComponent(value)}`;
    })
    .join('');

  return (
    <div className="achievements">
      {type === 'search' ? (
        <AchievementsViewSearch queryParams={queryParams} />
      ) : type === 'administered' ? (
        <AchievementsViewAdministered queryParams={queryParams} />
      ) : type === 'active' ? (
        <AchievementsViewUser queryParams={queryParams} />
      ) : type === 'available' ? (
        <AchievementsViewAvailable queryParams={queryParams} />
      ) : type === 'all' ? (
        <AchievementsViewAllAchievements queryParams={queryParams} />
      ) : null}
    </div>
  );
};

export default Achievements;
